// START: Loader Component
import React from "react";
import loaderImg from "../../assets/loader.svg";

// START: Loader Component
const Loader: React.FC = () => {
  return (
    <div className="h-screen flex items-center justify-center ">
      <img src={loaderImg} alt="loader" />
    </div>
  );
};
// END: Loader Component
export default Loader;
// END: Loader Component
